/* ==================================================
  Section - Collection Carousel
================================================== */

const initCollectionCarousels = () => {    
  const collectionCarousels = document.querySelectorAll('.collection-carousel-slider')
  if(collectionCarousels.length) {
    collectionCarousels.forEach((item) => {
      const carousel = new Splide(item, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '10px',
        pagination: false,
        mediaQuery: 'min',
        arrowPath: 'M1.86,20A18.14,18.14,0,1,1,20,38.14,18.14,18.14,0,0,1,1.86,20ZM0,20A20,20,0,1,1,20,40,20,20,0,0,1,0,20Zm17.48,5.39L18.8,26.7,25.5,20l-6.7-6.7-1.32,1.31L22.87,20Z',
        breakpoints: {
          768: {
            perPage: 3,
            perMove: 1            
          },
          1024: {
            perPage: 2,
            perMove: 1            
          },
          1280: {
            perPage: 3,
            perMove: 1            
          }
        }
      })      
      carousel.mount()

      const allSlides = carousel.Components.Slides.filter('.splide__slide')

      filterCollections = (e) => {
        const btn = e.currentTarget
        const wrapper = btn.closest('.collection-carousel')
        const splideList = wrapper.querySelector('.splide__list')
        const allBtns = btn.closest('.collection-carousel-filters').querySelectorAll('button')          

        Array.from(allBtns).forEach((item) => { item.classList.remove('is-active') })
        btn.classList.add('is-active')
        
        splideList.innerHTML = ''      
        
        carousel.destroy()

        Array.from(allSlides).forEach((item) => {
          if(btn.dataset.collection != "all") {
            if(item.slide.dataset.collection == btn.dataset.collection) {
              carousel.add(item.slide)
            }
          } else {
            carousel.add(item.slide)
          }
        })

        carousel.mount()

      }

    })
  }
}
window.addEventListener('load', () => { initCollectionCarousels() })